import {DatevWizardLoginState} from './datev-wizard-login.state';

export const initialDatevWizardLoginState: DatevWizardLoginState = {
  processing: false,
  error: undefined,
  errorCode: undefined,
  errorDescription: undefined
};
